import { registerGroup, registerImage, registerRect, registerWrapText } from "@visactor/vrender-kits";

export function loadRadioComponent() {
    registerGroup(), registerRect(), registerWrapText(), registerImage();
}
//# sourceMappingURL=register.js.map
